import { render, staticRenderFns } from "./Imgslider.vue?vue&type=template&id=718dde82&scoped=true&"
import script from "./Imgslider.vue?vue&type=script&lang=js&"
export * from "./Imgslider.vue?vue&type=script&lang=js&"
import style0 from "./Imgslider.vue?vue&type=style&index=0&id=718dde82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718dde82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
